/**
 * DataSourceBadge — U2 Piece A Leaf 1c Rule 14 Step 2 (2026-07-14 late).
 *
 * Small status pill showing which data-source mode MRT is running in.
 * Reads VITE_MRT_DATA_SOURCE via services/dataService.getDataSourceMode().
 *
 * Visible in dev + local-verify runs so operators can confirm the toggle
 * flipped correctly. Subtle grey for 'static' (default), green for
 * 'admin-api-generated'. Sandvik-brand aligned; small pill, top-right area.
 *
 * Not intrusive — a status indicator only. Not a toggle control (the
 * toggle happens at build time via env var).
 */
import { getDataSourceMode } from '@services/dataService';

const STYLES = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    borderRadius: '999px',
    fontSize: '11px',
    fontFamily: '"Sandvik Sans Text", system-ui, sans-serif',
    letterSpacing: '0.02em',
    lineHeight: 1.2,
    border: '1px solid',
  },
  static: {
    background: '#f4f4f4',
    color: '#4a4a4a',
    borderColor: '#dcdcdc',
  },
  adminApi: {
    background: '#e8f5e9',
    color: '#1b5e20',
    borderColor: '#a5d6a7',
  },
  dot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
  },
};

export default function DataSourceBadge() {
  const mode = getDataSourceMode();
  const isAdminApi = mode === 'admin-api-generated';
  const label = isAdminApi ? 'Data: admin-api' : 'Data: static';
  const dotColor = isAdminApi ? '#2e7d32' : '#9e9e9e';
  const style = { ...STYLES.base, ...(isAdminApi ? STYLES.adminApi : STYLES.static) };
  return (
    <span style={style} title={`MRT data source mode: ${mode}`}>
      <span style={{ ...STYLES.dot, background: dotColor }} />
      {label}
    </span>
  );
}
